import { resolveUrl } from "~/utils/url/urlResolver";

export interface QuoteNotificationUrlData {
  quoteNumber: string;
  account?: string;
  salesOrg?: string;
}

export function getQuoteDetailsUrl(data: QuoteNotificationUrlData) {
  const baseUrl = resolveUrl("/my-account/quotes/detail");
  const urlParams = new URLSearchParams({ id: data.quoteNumber });

  if (data.account) {
    urlParams.append("account", data.account);
  }
  if (data.salesOrg) {
    urlParams.append("salesOrg", data.salesOrg);
  }
  return `${baseUrl}?${urlParams.toString()}`;
}
